/**
 * Maps a template color name to its CSS background value for display purposes.
 * Used by the Colors filter icons and by TemplateColorSwatch to override
 * the computed swatch background when a template has an explicit `swatchColor`.
 */
export const COLOR_BACKGROUNDS = {
  Red: '#8A1F1F',
  Orange: '#F09E62',
  Yellow: '#FFE798',
  Green: '#627154',
  Blue: '#416497',
  Brown: '#796051',
  Purple: '#866D8E',
  Pink: '#F8DBDA',
  Beige: '#F0E8E2',
  Gray: '#E0E0E0',
  Black: '#333333',
  White: '#FFFFFF',
  Gold: 'linear-gradient(135deg, #8F5303 0%, #E4C269 28.65%, #FFE68A 42.71%, #F0D16F 55.21%, #BD8A1C 75%, #C59320 84.37%, #AB7613 100%)',
  'Rose Gold': 'linear-gradient(135deg, #89392D 0%, #DF9C7A 28.65%, #FFCBAF 42.71%, #E5A280 55.21%, #A65C47 72.92%, #9B4F3E 84.36%, #87392F 100%)',
  Silver: 'linear-gradient(135deg, #585550 0%, #908F8B 28.65%, #E5E5E5 42.71%, #BEBDBB 55.21%, #6C6965 75%, #6E6B66 84.37%, #585550 100%)',
} as const;

export type SwatchColor = keyof typeof COLOR_BACKGROUNDS;
